import "./../styles.scss";

import { LoadingOutlined } from "@ant-design/icons";
import { Radio, Select } from "antd";
import { notification, Spin } from "antd";
import { ROLE } from "constants/phase";
import { Field, Form, Formik } from "formik";
import { get, includes } from "lodash";
import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import { useOutletContext } from "react-router-dom";
import Select2 from "react-select";

import AccessControl from "../../../components/common/AccessControl/accessControl";
import CloseModal from "../../../components/icons/CloseModal";

const EditStorage = (props) => {
  const { Option } = Select;
  const {
    loder,
    setLoder,
    editmodalOpen,
    setEditmodalOpen,
    getStorageDetails,
    editStorage,
    editStorageDetails,
    setValidateLoader,
    validateLoder,
    storageValidation,
    setOrganizationSearch,
    options,
    disableOption,
    user,
    clientSetting,
    fromCentarliseStorage,
    getAssignedStorageOrganization,
  } = props;
  const { currentRole } = useOutletContext();
  const [storageName, setStorageName] = useState(get(editStorage, "storage_name", ""));
  const [bucketType, setBucketType] = useState("");
  const [env, setEnv] = useState("");
  const [file, setFile] = useState("");
  const [allowAcl, setAllowAcl] = useState(get(editStorage, "credentials.acl_allow_public", "no"));
  const [folderPath, setFolderPath] = useState(get(editStorage, "multiple_folder_path", ""));
  const [cdnSuffix, setcdnSuffix] = useState(get(editStorage, "credentials.cdn_suffix", ""));
  const [e2eUpload, setE2EUpload] = useState(false);
  const [userId] = useState(localStorage.getItem("__uid"));
  const [formValues, setFormValues] = useState([{}]);
  const [multipleFolderPath, setMultipleFolderPath] = useState([]);
  const [assignedOrganization, setAssignedOrganization] = useState([]);
  const [preAssignedOrganizations, setPreAssignedOrganizations] = useState([]);
  // const [defaultStorage, setDefaultStorage] = useState(get(editStorage, "defaultStorage", false));
  const [initialState] = useState({ ...editStorage });
  const [selectedlist, setSelectedList] = useState([]);
  const [validate, setValidate] = useState(false);
  const [updateDisable, setUpdateDisable] = useState(false);

  const [selectedOrganization, setSelectedOrganization] = useState([]);

  const [cred, setCred] = useState(
    get(editStorage, "credentials", {
      secret_key: "",
      access_key: "",
      region: "",
      bucket_name: "",
      ns_hostname: "",
      ns_keyname: "",
      ns_key: "",
      ns_cpcode: "",
      connection_string: "",
      folder_path: "",
      cdn_suffix: "",
      acl_allow_public: "",
      gcp_bucket_name: "",
      gcp_file_credentials: "",
      gcp_keys: "",
    }),
  );

  useEffect(() => {
    if (editStorage?.multiple_folder_path?.length) {
      setFormValues(editStorage.multiple_folder_path);
    } else {
      setFormValues([{ multiple_folder_path: "" }]);
    }
    if (currentRole === ROLE.SUPER_ADMIN) {
      getAssignedStorage(editStorage._id);
    }
  }, [editStorage]);

  const getAssignedStorage = async (id) => {
    //get list of all organizations/sub org which is assigned to this storage
    const { value } = await getAssignedStorageOrganization({ id });
    if (value?.success) {
      setSelectedList(value?.organizations || []);
      setPreAssignedOrganizations(value?.organizations || []);
      const orgs = (value?.organizations || []).map((item) => ({ label: item.name, value: item.organizationId }));

      setSelectedOrganization(orgs || []); //set org
    }
  };

  const handleOrgChange = (e) => {
    setSelectedList(e);
    setSelectedOrganization(e);
  };

  function hasEmptyKey(array, key) {
    return array.filter((obj) => obj.hasOwnProperty(key) && obj[key] !== "");
  }

  const handleSubmit = async (payload = { ...initialState }) => {
    const selectedOrgs = selectedOrganization?.map(({ value }) => value);
    const filtered_array = hasEmptyKey(formValues, "multiple_folder_path");
    let newElements = [],
      removedElements = [];
    if (currentRole === ROLE.SUPER_ADMIN) {
      newElements = selectedOrgs.filter((element) => !preAssignedOrganizations.includes(element));
      removedElements = preAssignedOrganizations.filter((element) => !selectedOrgs.includes(element));
    }
    payload.credentials = cred;
    payload.storage_name = storageName;
    payload.credentials.acl_allow_public = allowAcl;
    payload.credentials.multiple_folder_path = filtered_array;
    payload.credentials.cdn_suffix = cdnSuffix;
    payload.multiple_folder_path = filtered_array;
    // payload.defaultStorage = defaultStorage;
    payload.addOrganization = newElements;
    payload.removeOrganization = removedElements;
    if (validate) {
      payload.isValidate = true;
      payload.truelastValidateDate = new Date();
    }
    if (currentRole === ROLE.ADMIN) {
      payload._id = payload.reference_id;
    }
    setLoder(true);
    let data = await editStorageDetails(payload);
    if (data?.value?.success) {
      notification["success"]({ message: data?.value.message });
      getStorageDetails();
      setLoder(false);
      closeModal();
    } else {
      closeModal();
      notification["error"]({ message: data?.value.message });
    }
  };

  const openModal = () => {
    setEditmodalOpen(true);
  };
  const closeModal = () => {
    setEditmodalOpen(false);
    setOrganizationSearch("");
    setSelectedOrganization([]);
    setValidate(false);
  };

  const onChangeFolderPath = (i, e, setFieldValue) => {
    let newFormValues = [...formValues];
    newFormValues[i][e.target.name] = e.target.value;
    setFormValues(newFormValues);
    setFieldValue("multiple_folder_path", formValues);
    // setFieldValue("folder_path", e.target.value);
  };
  const handleValidatedata = (dirty) => {
    if (updateDisable != dirty) {
      if (dirty) {
        setUpdateDisable(true);
      } else {
        setUpdateDisable(false);
      }
    }
  };
  //to fetch multiple folder path values
  const handleClick = () => {
    setFormValues([...formValues, { multiple_folder_path: "" }]);
  };

  //validation function
  const validateStorage = async (values, resetForm) => {
    // values.credentials.storage_name = storageName;
    // values.credentials.acl_allow_public = allowAcl;
    // values.credentials.cdn_suffix = cdnSuffix;
    // values.multiple_folder_path = formValues;
    // values.defaultStorage = defaultStorage;

    setValidateLoader(true);
    const data = await storageValidation({
      ...values?.credentials,
      isExistingStorage: "true",
      storageType: values?.name,
      bucket_type: initialState.storage_type,
      _id: currentRole === ROLE.ADMIN ? initialState.reference_id : initialState._id,
      region: values?.credentials?.display_region,
    });
    resetForm({ values });
    if (data?.value?.status) {
      notification["success"]({ message: data?.value?.message });
      setValidate(true);
      // getStorageDetails();
      setUpdateDisable(false);
    } else {
      notification["error"]({ message: data?.value?.message });
      setValidate(false);
      setUpdateDisable(true);
      // getStorageDetails();
    }
    setValidateLoader(false);
  };

  return (
    <>
      <Modal
        isOpen={editmodalOpen}
        onRequestClose={closeModal}
        shouldCloseOnOverlayClick={false}
        contentLabel="Storage Modal"
        portalClassName="react-modal"
        overlayClassName="modal"
        className="modal-dialog react-modal-dialog-lg modal-dialog-centered filter-modal"
      >
        <Formik initialValues={initialState} onSubmit={handleSubmit}>
          {({ dirty, values, errors, touched, setFieldValue, resetForm }) => (
            <div className="modal-content">
              {dirty && handleValidatedata(dirty)}
              <Form>
                <div className="react-modal-header">
                  <h5 className="react-modal-title">{disableOption ? "View Storage" : "Edit Storage"}</h5>
                  <button type="button" onClick={closeModal} className="btn btn__default">
                    <CloseModal />
                  </button>
                </div>
                <div className="react-modal-body">
                  <div className="add-form-contianer">
                    {fromCentarliseStorage && (
                      <>
                        <AccessControl code="select_admin_user" page="organization-profile">
                          <div className="form-group custom-search-select">
                            <label className="form-label">
                              Organizations<span className="required"></span>
                            </label>
                            <Select2
                              styles={{ width: "100%" }}
                              isMulti={true}
                              bordered={false}
                              value={selectedOrganization}
                              closeMenuOnSelect={false}
                              onChange={(e) => {
                                handleOrgChange(e);
                              }}
                              onInputChange={(e) => {
                                setOrganizationSearch(e);
                              }}
                              name="organizations"
                              options={options}
                            />
                          </div>
                        </AccessControl>
                      </>
                    )}
                    <div className="three-column-row">
                      <div class="form-group">
                        <label className="form-label">Cloud Type</label>
                        <div class="input-block">
                          <Field
                            name="name"
                            component={Select}
                            dropdownStyle={{ zIndex: 99999999 }}
                            className="custom-ant-select"
                            disabled={true}
                            defaultValue={initialState.name}
                          >
                            <Option value="aws">AWS S3</Option>
                            <Option value="akamai">AKAMAI</Option>
                            <Option value="gcp">GCP</Option>
                            <Option value="azure">Azure</Option>
                          </Field>
                        </div>
                      </div>
                      <div class="form-group">
                        <label className="form-label">Bucket Type</label>
                        <Field
                          name="storage_type"
                          onChange={(value) => setBucketType(value)}
                          component={Select}
                          dropdownStyle={{ zIndex: 99999999 }}
                          disabled={true}
                          className="custom-ant-select"
                          placeholder="Select Bucket Type"
                          value={initialState.storage_type}
                        >
                          <Radio value={"production"}>Production</Radio>
                          <Radio value={"story"}>Story Storage</Radio>
                        </Field>
                      </div>
                      <div class="form-group">
                        <label className="form-label">Environment</label>
                        <div className="input-block fill-radio-custom">
                          <Radio.Group
                            defaultValue="Production"
                            disabled={true}
                            onChange={(e) => setEnv(e.target.value)}
                          >
                            <Radio.Button value="Production">Production</Radio.Button>
                            <Radio.Button value="QA">QA</Radio.Button>
                          </Radio.Group>
                        </div>
                      </div>
                    </div>
                    {editStorage.name === "aws" ? (
                      <>
                        <div className="three-column-row">
                          <div class="form-group">
                            <label className="form-label">Bucket Name</label>
                            <Field
                              disabled={true}
                              name="bucket_name"
                              type="text"
                              placeholder="Enter Bucket Name"
                              className="form-control"
                              onChange={(e) => {
                                setFieldValue("credentials.display_bucket_name", e.target.value);
                              }}
                              value={get(initialState, "credentials.display_bucket_name", "")}
                            />
                            {touched.bucket_name && errors.bucket_name && (
                              <div className="invalid-feedback">{errors.bucket_name}</div>
                            )}
                          </div>
                          <div class="form-group">
                            <label className="form-label">Secret Key</label>
                            <Field
                              name="secret_key"
                              type="text"
                              placeholder="Enter Secret Key"
                              className="form-control"
                              disabled={disableOption}
                              onChange={(e) => {
                                setFieldValue("credentials.secret_key", e.target.value);
                                setCred((prevState) => ({ ...prevState, secret_key: e.target.value }));
                              }}
                              value={get(values, "credentials.secret_key", "")}
                            />
                            {touched.secret_key && errors.secret_key && (
                              <div className="invalid-feedback">{errors.secret_key}</div>
                            )}
                          </div>
                        </div>
                        <div className="three-column-row">
                          <div class="form-group">
                            <label className="form-label">Access Key</label>
                            <Field
                              name="access_key"
                              type="text"
                              placeholder="Enter Access Key"
                              className="form-control"
                              disabled={disableOption}
                              onChange={(e) => {
                                setFieldValue("credentials.access_key", e.target.value);
                                setCred((prevState) => ({ ...prevState, access_key: e.target.value }));
                              }}
                              value={get(values, "credentials.access_key", "")}
                            />
                            {touched.access_key && errors.access_key && (
                              <div className="invalid-feedback">{errors.access_key}</div>
                            )}
                          </div>
                          <div class="form-group">
                            <label className="form-label">Bucket Region</label>
                            <Field
                              name="region"
                              type="text"
                              placeholder="Enter Bucket Region"
                              className="form-control"
                              disabled={disableOption}
                              onChange={(e) => {
                                setFieldValue("credentials.region", e.target.value);
                                setFieldValue("credentials.display_region", e.target.value);
                                setCred((prevState) => ({ ...prevState, region: e.target.value }));
                              }}
                              value={get(values, "credentials.display_region", "")}
                            />
                            {touched.region && errors.region && <div className="invalid-feedback">{errors.region}</div>}
                          </div>
                          {/* <div class="form-group">
                            <label className="form-label">E2E Upload</label>
                            <div className="input-block fill-radio-custom">
                              <Radio.Group
                                defaultValue={false}
                                disabled={true}
                                onChange={(e) => setE2EUpload(e.target.value)}
                              >
                                <Radio.Button value={true}>Yes</Radio.Button>
                                <Radio.Button value={false}>No</Radio.Button>
                              </Radio.Group>
                            </div>
                          </div> */}
                        </div>{" "}
                      </>
                    ) : null}
                    {editStorage.name === "akamai" ? (
                      <>
                        <div className="three-column-row">
                          <div class="form-group">
                            <label className="form-label">NS HOSTNAME</label>
                            <Field
                              name="ns_hostname"
                              type="text"
                              placeholder="Enter Host Name"
                              className="form-control"
                              disabled={disableOption}
                              onChange={(e) => {
                                setFieldValue("credentials.ns_hostname", e.target.value);
                                setCred((prevState) => ({ ...prevState, ns_hostname: e.target.value }));
                              }}
                              value={get(values, "credentials.ns_hostname", "")}
                            />
                            {touched.ns_hostname && errors.ns_hostname && (
                              <div className="invalid-feedback">{errors.ns_hostname}</div>
                            )}
                          </div>

                          <div class="form-group">
                            <label className="form-label">NS KEYNAME</label>
                            <Field
                              name="ns_keyname"
                              type="text"
                              placeholder="Enter Key Name"
                              className="form-control"
                              disabled={disableOption}
                              onChange={(e) => {
                                setFieldValue("credentials.ns_keyname", e.target.value);
                                setCred((prevState) => ({ ...prevState, ns_keyname: e.target.value }));
                              }}
                              value={get(values, "credentials.ns_keyname", "")}
                            />
                            {touched.ns_keyname && errors.ns_keyname && (
                              <div className="invalid-feedback">{errors.ns_keyname}</div>
                            )}
                          </div>
                        </div>
                        <div className="three-column-row">
                          <div class="form-group">
                            <label className="form-label">NS KEY</label>
                            <Field
                              name="ns_key"
                              type="text"
                              placeholder="Enter Key"
                              className="form-control"
                              disabled={disableOption}
                              onChange={(e) => {
                                setFieldValue("credentials.ns_key", e.target.value);
                                setCred((prevState) => ({ ...prevState, ns_key: e.target.value }));
                              }}
                              value={get(values, "credentials.ns_key", "")}
                            />
                            {touched.ns_key && errors.ns_key && <div className="invalid-feedback">{errors.ns_key}</div>}
                          </div>
                          <div class="form-group">
                            <label className="form-label">NS CPCODE</label>
                            <Field
                              name="ns_cpcode"
                              type="text"
                              placeholder="Enter CP Code"
                              className="form-control"
                              disabled={disableOption}
                              onChange={(e) => {
                                setFieldValue("credentials.ns_cpcode", e.target.value);
                                setCred((prevState) => ({ ...prevState, ns_cpcode: e.target.value }));
                              }}
                              value={get(values, "credentials.ns_cpcode", "")}
                            />
                            {touched.ns_cpcode && errors.ns_cpcode && (
                              <div className="invalid-feedback">{errors.ns_cpcode}</div>
                            )}
                          </div>
                        </div>
                      </>
                    ) : null}
                    {editStorage.name == "gcp" ? (
                      <>
                        <div className="three-column-row">
                          <div class="form-group">
                            <label className="form-label">Bucket Name</label>
                            <Field
                              name="gcp_bucket_name"
                              type="text"
                              placeholder="Enter Bucket Name"
                              className="form-control"
                              disabled={true}
                              onChange={(e) => {
                                setFieldValue("credentials.display_bucket_name", e.target.value);
                                setCred((prevState) => ({ ...prevState, display_bucket_name: e.target.value }));
                              }}
                              value={get(values, "credentials.display_bucket_name", "")}
                            />
                            {touched.gcp_bucket_name && errors.gcp_bucket_name && (
                              <div className="invalid-feedback">{errors.gcp_bucket_name}</div>
                            )}
                          </div>
                        </div>
                      </>
                    ) : null}
                    {editStorage.name == "azure" ? (
                      <>
                        <div className="three-column-row">
                          <div class="form-group">
                            <label className="form-label">Bucket Name</label>
                            <Field
                              name="bucketname"
                              type="text"
                              placeholder="Enter Bucket Name"
                              className="form-control"
                              disabled={disableOption}
                              onChange={(e) => {
                                setFieldValue("credentials.bucketname", e.target.value);
                                setCred((prevState) => ({ ...prevState, bucketname: e.target.value }));
                              }}
                              value={get(values, "credentials.display_bucket_name", "")}
                            />
                            {touched.bucketname && errors.bucketname && (
                              <div className="invalid-feedback">{errors.bucketname}</div>
                            )}
                          </div>
                          <div class="form-group">
                            <label className="form-label">Connection String</label>
                            <Field
                              name="connectionstring"
                              type="text"
                              placeholder="Enter Connection String"
                              className="form-control"
                              disabled={true}
                              onChange={(e) => {
                                setFieldValue("credentials.connectionstring", e.target.value);
                                setCred((prevState) => ({ ...prevState, connectionstring: e.target.value }));
                              }}
                              value={get(values, "credentials.connectionstring", "")}
                            />
                            {touched.connectionstring && errors.connectionstring && (
                              <div className="invalid-feedback">{errors.connectionstring}</div>
                            )}
                          </div>
                        </div>
                      </>
                    ) : null}

                    {clientSetting?.permissions?.multipleStoragePath == true && currentRole !== ROLE.SUPER_ADMIN ? (
                      formValues.map((element, index) => {
                        return (
                          <>
                            <div class="form-group">
                              <label className="form-label">Bucket Folder Path {index + 1}</label>
                              <Field
                                name="multiple_folder_path"
                                type="text"
                                disabled={disableOption}
                                value={element.multiple_folder_path}
                                className="form-control"
                                onChange={(e) => onChangeFolderPath(index, e, setFieldValue)}
                              />
                            </div>

                            {index === formValues.length - 1 && !disableOption && (
                              <button
                                type="button"
                                disabled={includes([null, "", undefined, "null"], element.multiple_folder_path)}
                                className="btn btn-primary btn-small"
                                onClick={() => handleClick()}
                              >
                                Add More Bucket Folder Path
                              </button>
                            )}
                          </>
                        );
                      })
                    ) : (
                      <div class="form-group">
                        <label className="form-label">Bucket Folder Path</label>
                        <Field
                          name="folder_path"
                          type="text"
                          placeholder="Enter Bucket Path"
                          className="form-control"
                          disabled={true}
                          onChange={(e) => {
                            setFieldValue("folder_path", e.target.value);
                            setCred((prevState) => ({ ...prevState, folder_path: e.target.value }));
                          }}
                          value={get(values, "credentials.folder_path", "")}
                        />
                      </div>
                    )}
                    <div className="three-column-row">
                      <div class="form-group">
                        <label className="form-label">Storage Name</label>
                        <Field
                          name="storage_name"
                          type="text"
                          placeholder="Enter Storage Name"
                          className="form-control"
                          onChange={(e) => {
                            setStorageName(e.target.value);
                            setFieldValue("storage_name", e.target.value);
                          }}
                          value={get(values, "storage_name", "")}
                          disabled={disableOption}
                        />
                        {touched.storage_name && errors.storage_name && (
                          <div className="invalid-feedback">{errors.storage_name}</div>
                        )}
                      </div>
                      <div class="form-group">
                        <label className="form-label">CDN</label>
                        <Field
                          name="cdn_suffix"
                          type="text"
                          placeholder="Enter CDN Suffix"
                          className="form-control"
                          disabled={disableOption}
                          onChange={(e) => {
                            setFieldValue("credentials.cdn_suffix", e.target.value);
                            setcdnSuffix(e.target.value);
                          }}
                          value={get(values, "credentials.cdn_suffix", "")}
                        />
                        {touched.cdn_suffix && errors.cdn_suffix && (
                          <div className="invalid-feedback">{errors.cdn_suffix}</div>
                        )}
                      </div>
                    </div>
                    <div className="three-column-row">
                      <div class="form-group">
                        <label className="form-label">Allow ACL</label>
                        <div className="input-block fill-radio-custom">
                          <Radio.Group
                            defaultValue="yes"
                            onChange={(e) => {
                              setAllowAcl(e.target.value);
                              setFieldValue("credentials.acl_allow_public", e.target.value);
                            }}
                            value={get(values, "credentials.acl_allow_public", "no")}
                            disabled={disableOption}
                          >
                            <Radio.Button value="yes">Yes</Radio.Button>
                            <Radio.Button value="no">No</Radio.Button>
                          </Radio.Group>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="react-modal-footer">
                  <div className="react-foo-container">
                    <div className="right-btn-block text-md-end text-center">
                      <button type="button" className="btn btn-white" onClick={closeModal}>
                        Cancel
                      </button>
                      {!disableOption && (
                        <AccessControl code="edit_storage" page="organization-profile">
                          {(initialState?.name == "aws" || initialState?.name == "gcp") && (
                            <button
                              type="button"
                              disabled={validateLoder}
                              className="btn btn-primary"
                              onClick={() => validateStorage(values, resetForm)}
                            >
                              {validateLoder ? "Validating..." : "Validate"}
                            </button>
                          )}
                          <button type="submit" className="btn btn-primary" disabled={updateDisable}>
                            Update
                            {loder && (
                              <Spin
                                size="large"
                                indicator={
                                  <LoadingOutlined style={{ fontSize: 50, color: "#000", marginLeft: 50 }} spin />
                                }
                                className="loader__full"
                              ></Spin>
                            )}
                          </button>
                        </AccessControl>
                      )}
                    </div>
                  </div>
                </div>
              </Form>
            </div>
          )}
        </Formik>
      </Modal>
    </>
  );
};
export default EditStorage;
